import React, { useEffect, useReducer } from 'react'
import { Columns, State } from './Model'
import Table from './Table'
import reducer, { Action } from './reducer'

type Props = {
    initialData: { columns: Columns[], data: any, skipReset: boolean, model: any, modelPath: string, propertyName: string }
    onChange: { (changes: any, callback?: { (): any }): any }
    uniqueSelectSelection: boolean
    selectedCategories: string[]
    rowAddedHandler?: { (): any }
    rowRemovedHandler?: { (index: number): any }
    maximumRows?: number
    tableName?: string
    multipleFooter?: boolean
    onFooter2ValueChange?: { (name: string, value: string): any }
}

// to do Make it react fc component
function Index(props: Props) {
  const {
    initialData, onChange, initialData: { model, modelPath, propertyName }, uniqueSelectSelection, selectedCategories,
    rowAddedHandler,
    rowRemovedHandler,
    maximumRows,
    tableName,
    multipleFooter,
    onFooter2ValueChange,
  } = props
  // to do change any type to proper type
  const [state, dispatch]: [State, any] = useReducer<React.Reducer<State, Action>>(
    reducer,
    initialData,
  )

  useEffect(() => {
    dispatch({ type: 'enable_reset' })

    if (JSON.stringify(model[modelPath]) !== JSON.stringify(state.data)) {
      onChange({ [propertyName]: state.data })
    }
  }, [state.data, state.columns])

  return (
    <div className="container-editable-table">
      <Table
        columns={state.columns}
        data={state.data}
        dispatch={dispatch}
        skipReset={state.skipReset}
        uniqueSelectSelection={uniqueSelectSelection}
        selectedCategories={selectedCategories}
        rowAddedHandler={rowAddedHandler}
        rowRemovedHandler={rowRemovedHandler}
        maximumRows={maximumRows}
        tableName={tableName}
        multipleFooter={multipleFooter}
        onFooter2ValueChange={onFooter2ValueChange}
      />
    </div>
  )
}

export default Index
